<template>
  <div class="page-main">
    <page-title />

    <page-card :noHead="true" class="no-padding">
      <!-- <template slot="tab">
        <el-tabs v-model="activeName" class="page-tab">
          <el-tab-pane name="1" >
            <span slot="label"><svg-icon icon-class="tn-mineral" /> Mineral</span>
          </el-tab-pane>
          <el-tab-pane name="2" >
            <span slot="label"><svg-icon icon-class="tn-digital" /> Digital</span>
          </el-tab-pane>
        </el-tabs>
      </template> -->
      <div slot="body" class="page-table">
        <mineral v-if="activeName==1"/>
        <digital v-if="activeName==2"/>
      </div>
    </page-card>
  </div>
</template>

<script>
import mineral from "./components/mineral.vue"
import digital from "./components/digital.vue"

export default {
  components: {
    mineral,
    digital
  },
  data() {
    return {
      activeName:"1",

    };
  },
  computed: {},
  methods: {

  },
  created() {
  },
};
</script>
<style scoped lang="scss">

</style>
